import CountryCode from "../enum/CountryCode";
import AreaRegion from "../types/territory/AreaRegion";
import { CountryState } from "../types/territory/CountryState";

const parseCountryState = (
  countryState: CountryState
): { areaRegionId: AreaRegion["id"]; countryCode: CountryCode } => {
  const [countryCode, areaRegionId] = countryState.split("_");
  return { areaRegionId, countryCode: countryCode as CountryCode };
};

export default parseCountryState;
